<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    class="left-sidebar">
    <v-layout
      justify-center
      wrap>
        <v-flex
        md12>
        <v-card
        elevation="2"
        class="card-body">
        <v-card>
            <v-card-title>{{ $t('categories.editCategory')}} {{ getCategoryName }}</v-card-title>
        </v-card>
        <v-spacer/>
            <v-form ref="editCategoryForm">
              <v-card-text>
                  <v-container grid-list-md mt-12>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="categoryName"
                            :label="$t('categories.name')"
                            :placeholder="$t('categories.name')"
                            :error-messages="categoryNameErrors"
                          />
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-select
                            v-model="products"
                            :items="getAllProducts"
                            :label="$t('categories.products')"
                            :placeholder="$t('categories.products')"
                            item-text="title"
                            item-value="id"
                            multiple
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="sku"
                            :label="$t('categories.sku')"
                            :placeholder="$t('categories.sku')"
                            :error-messages="skuErrors"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="sortBoxNo"
                            :label="$t('categories.sortBoxNo')"
                            :placeholder="$t('categories.sortBoxNo')"
                            :error-messages="sortBoxNoErrors"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="metaTitle"
                            :label="$t('categories.metaTitle')"
                            :placeholder="$t('categories.metaTitle')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md9>
                        <v-text-field
                            v-model="metaDescription"
                            :label="$t('categories.metaDescription')"
                            :placeholder="$t('categories.metaDescription')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md6>
                        <v-text-field
                            v-model="metaKeywords"
                            :label="$t('categories.metaKeywords')"
                            :placeholder="$t('categories.metaKeywords')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md6>
                        <v-text-field
                            v-model="metaUrl"
                            :label="$t('categories.metaUrl')"
                            :placeholder="$t('categories.metaUrl')"
                          />
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                            v-model="metaImage"
                            :label="$t('categories.metaImage')"
                            :placeholder="$t('categories.metaImage')"
                          />
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                          <v-checkbox
                              v-model="isActiveWeb"
                              :label="$t('categories.web')"
                          ></v-checkbox>
                      </v-flex>
                       <v-flex xs12 sm6 md2>
                            <v-checkbox
                                v-model="isActiveMobile"
                                :label="$t('categories.mobile')"
                            ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                            <span>{{ $t('categories.categoryImage') }}</span><br><br>
                            <div class="img-wrapper">
                                <i class="mdi mdi-delete delete delete-sign-category image"  title="delete" @click="removeImage()"></i>
                                <img class="uploaded-img" id="categoryImage">
                            </div><br><br>
                            <input @change="setEditImage()" id="category-image-edit" type='file' accept="image/*"/>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                            <span>{{ $t('categories.icon') }}</span><br><br>
                            <div class="img-wrapper">
                            <i class="mdi mdi-delete delete delete-sign-category-icon icon"  title="delete" @click="removeIcon()"></i>
                            <img id="categoryIcon" class="icon-img">
                            </div><br><br>
                            <input @change="setEditIcon()" id="category-icon-edit" type='file' accept="image/*"/><br>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                            <v-color-picker v-model="color"
                                    mode="hexa"
                                    hide-mode-switch></v-color-picker>
                            <!-- <span>{{ showColor }}</span> -->
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        class="add-new mb-1 mt-8 mr-3" dark
                        @click="cancelCategory()">{{ $t('cancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="add-new mb-1 mt-8 mr-3" dark
                        @click="deleteCategory()">{{ $t('delete')}}</v-btn>
                    <v-btn
                        class="add-new mb-1 mt-8 mr-3" dark
                        @click="editCategory()">{{ $t('submit')}}</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <giftric-subcategories></giftric-subcategories>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {  mapGetters } from 'vuex';
  import { required, numeric } from 'vuelidate/lib/validators'
  import i18n from '../../i18n'
  import axios from 'axios'
  import Vue from 'vue'
  import Subcategories from '../dashboardViews/Subcategories.vue';
  export default {
      data () {
          return {
            categoryName: '',
            products: [],
            productsLength: null,
            sku: '',
            sortBoxNo: '',
            metaTitle: '',
            metaDescription: '',
            metaKeywords: '',
            metaUrl: '',
            metaImage: '',
            isActiveWeb: false,
            isActiveMobile: false,
            urlCategoryId: null,
            type: 'hex',
            hex: '#FF00FF',
            rmImage: false,
            rmIcon: false,
          }
      },
      validations: {
          categoryName: { required },
          sku: { required },
          sortBoxNo: { required, numeric }
      },
      computed: {
        ...mapGetters([
            'getAllProducts',
            'getCategory',
            'getCategoryName',
            'getCategoryTranslations'
        ]),
        color: {
            get () {
                return this[this.type];
            },
            set (v) {
                    this[this.type] = v;
                },
        },
        showColor () {
            if (typeof this.color === 'string') return this.color

            return JSON.stringify(Object.keys(this.color).reduce((color, key) => {
                color[key] = Number(this.color[key].toFixed(2))
                return color
            }, {}), null, 2)
        },
        categoryNameErrors(){
            const errors = [];
                if (!this.$v.categoryName.$dirty) return errors;
                    !this.$v.categoryName.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        skuErrors(){
            const errors = [];
                if (!this.$v.sku.$dirty) return errors;
                    !this.$v.sku.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        sortBoxNoErrors(){
            const errors = [];
                if (!this.$v.sortBoxNo.$dirty) return errors;
                    !this.$v.sortBoxNo.numeric && errors.push(i18n.tc('fieldValueNumber'));
                    !this.$v.sortBoxNo.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        }
      },
      methods: {
        setEditImage(){
          const editImage = document.getElementById('category-image-edit').files[0];
          let output = document.getElementById('categoryImage');
              output.src = URL.createObjectURL(editImage);

              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
      },
      setEditIcon(){
          const editImage = document.getElementById('category-icon-edit').files[0];
          let output = document.getElementById('categoryIcon');
              output.src = URL.createObjectURL(editImage);

              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
      },
        resetCategoryForm(){
            this.$refs.editCategoryForm.reset();
            this.$v.$reset();
            document.getElementById('category-image-edit').value = '';
            document.getElementById('category-icon-edit').value = '';
        },
        cancelCategory(){
            this.resetCategoryForm();
            this.$router.push(`/${i18n.locale}/categories`);
        },
        editCategory(){
          const categoryFileEdit = document.getElementById('category-image-edit').files[0],
                categoryIconEdit = document.getElementById('category-icon-edit').files[0],
                categoryId = this.urlCategoryId;

            let formData = new FormData();
              formData.append('categoryId', this.urlCategoryId);

              if (categoryFileEdit || this.rmImage) {
                formData.append('image', categoryFileEdit || null);
              }

              if(categoryIconEdit || this.rmIcon){
                 formData.append('icon', categoryIconEdit || null);
              }

              let sku = localStorage.getItem('sku_category')
                if(sku != this.sku){
                   formData.append('sku', this.sku);
              } 

              formData.append('position', this.sortBoxNo);
              formData.append('enable_mobile', this.isActiveMobile);
              formData.append('enable_web', this.isActiveWeb);
              formData.append('color', this.showColor);
              const translations = [
                {
                  'name': this.categoryName,
                  'meta_title': this.metaTitle,
                  'meta_description': this.metaDescription,
                  'meta_keywords': this.metaKeywords,
                  'meta_url': this.metaUrl,
                  'meta_image': this.metaImage,
                  'language_identifier': 'sr',
                }
              ]

              formData.append(
                  'translations', new Blob([JSON.stringify(translations)], {type: 'application/json'})
              )

              const productIds = this.products.length == this.productsLength
                  ? this.products.map(product => product.id)
                  : this.products;

              formData.append(
                  'product_ids', new Blob([JSON.stringify(productIds)],
                      {type: 'application/json'})
              )

            if(this.$v.categoryName.$invalid || this.$v.categoryName.$sku
                 || this.$v.sortBoxNo.$invalid){
                this.$v.$touch();
                return;
            } else {
              return new Promise((resolve) => {
                axios.put(`category/${categoryId}`, formData)
                  .then(resp => {
                    if(!resp.data.error){
                          Vue.toasted.show(i18n.tc(`successfully`),{
                              theme: 'outline',
                              singleton: true,
                              position:'top-center',
                              action :
                                {
                                    text : i18n.tc(`ok`),
                                    onClick : (e, toastObject) => {
                                        toastObject.goAway(0);
                                        this.$router.push(`/${i18n.locale}/categories`);
                                    }
                                }
                          });
                          this.$store.dispatch('LOAD_ALL_CATEGORIES')
                          localStorage.removeItem('sku_category');
                    } else {
                      console.log(resp.data.error)
                    }
                resolve(resp)
                })
              })
            }
        },
        deleteCategory(){
            if (confirm(i18n.t(`areYouSureToDelete`))) {
              this.$store.dispatch('DELETE_CATEGORY', this.$route.params.id)
                  .then(() => this.$store.dispatch('LOAD_ALL_CATEGORIES'));
                  this.$router.push(`/${i18n.locale}/categories`);
            }
        },
        removeImage(){
           if (confirm(i18n.t(`areYouSureToDelete`))) {
                 document.getElementById('categoryImage').style.display = 'none';
                 document.querySelector('.image').remove();
                 this.rmImage = true;
           }
        },
        removeIcon(){
            if (confirm(i18n.t(`areYouSureToDelete`))) {
                  document.getElementById('categoryIcon').style.display = 'none';
                  document.querySelector('.icon').remove();
                  this.rmIcon = true;
           }
        }
      },
      beforeCreate() {
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
      },
      mounted() {
          this.urlCategoryId = this.$route.params.id;
          this.$store.dispatch('LOAD_ALL_PRODUCTS');

        this.$store.dispatch('GET_CATEGORY', this.urlCategoryId)
            .then(res => {
                let response = res.data.data;
                this.categoryName = response.name;
                this.products = response.products,
                this.productsLength = response.products.length,
                this.sku = response.sku,
                this.sortBoxNo = response.position,
                this.isActiveWeb = response.enable_web,
                this.isActiveMobile = response.enable_mobile,
                this.color = response.color,
                this.metaTitle = response.translations[0].meta_title,
                this.metaDescription = response.translations[0].meta_description,
                this.metaKeywords = response.translations[0].meta_keywords,
                this.metaUrl = response.translations[0].meta_url,
                this.metaImage = response.translations[0].meta_image,
                document.getElementById('categoryImage').src = response.image;
                document.getElementById('categoryIcon').src = response.icon;
                localStorage.setItem('sku_category', response.sku);
            })
      },
      components:{
        'giftric-subcategories': Subcategories
      }
  }
</script>

<style lang="less">

</style>
